import {FormatDataTable} from '../formatDataTable';


export class DataTableOnLoad extends FormatDataTable {

    constructor(item, data) {

        super();

        let self = this;
        window.saveCost = this.saveCost.bind(this);
        let updateButton='-';

        if (item.product_code!='undefined' && item.product_code!=''){
            updateButton=self.updateCostButton(data, item, '');
        }
        return [
            item.id,
            self.orderViewButton(data,item),
            this.integrationLogo(item.integration_id),
            item.name,
            '<b>' + item.sku + '</b> ',
            self.costColumn(item),
            item.unit_price,
            self.productCodeColumn(item),
            self.convertDate(item.created_at),
            updateButton

        ];
    }


    productCodeColumn(item) {
        if (item.product_code === null) {
            return '-';
        }

        const removeButton = item.product_code ? `
                <br><span class="btn btn-warning btn-circle btn-sm open-modal" data-url="` + window.baseUrl('admin/remove-product-code/' + item.id) + `" title="Ürün kodunu kaldır">
                    <i class="fas fa-times"></i>
                </span>
            ` : '';

        //return '<div class="text-center">' + item.product_code + removeButton + '</div>';
        return '<div class="text-center">' + item.product_code + '</div>';
    }

    convertDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString('en-GB', { // Change to desired locale
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    integrationLogo(id) {
        let integrationIcon = '-';
        if (id != null) {
            integrationIcon = `<img src="/img/integrations/` + id + `.png" class="vendor-img-sm" alt="integrator" title="integrator">`;
        }

        return `
            <div class="text-center">
                ` + integrationIcon + `
            </div>`;
    }
    // costColumn:
    costColumn(item) {
        return ''
            + '<div class="input-group input-group-sm" style="width:auto;">'
            +   `<input
         type="number"
         id="unit-price-cost-${item.id}"
         name="unit_price_cost"
         value="${item.unit_cost_price}"
         class="form-control form-control-sm js-updatable-input hide-arrows"
         style="background-color:#f5f5f5; color:#999;"
       />`
            +   '<div class="input-group-append">'
            +     '<span class="input-group-text js-focusable">$</span>'
            +   '</div>'
            +   '<div class="input-group-append">'
            +     `<button
           class="btn btn-primary"
           onclick="saveCost(${item.id})"
         >Save</button>`
            +   '</div>'
            + '</div>'
            + `<div id="sucsess-message-${item.id}" class="alert alert-success" style="display: none">İşlem Başarılı!</div>`
            + `<div id="error-message-${item.id}" class="alert alert-danger" style="display: none">İşlem Başarısız!</div>`;
    }



    saveCost(id) {
        let data = {
            unit_cost_price: $(`#unit-price-cost-${id}`).val(),
        };

        $.ajax({
            type: 'PATCH',
            url: `/admin/admin_order_product_cost/${id}`,
            dataType: 'json',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        })
            .done(result => {
                $('#sucsess-message-'+id).css('display','block');
                setTimeout(function () {
                    $('#sucsess-message-'+id).css('display','none');
                },3000)
            })
            .fail(xhr => {
                alert(xhr.responseJSON.message);
                $('#error-message-'+id).css('display','block');
                setTimeout(function () {
                    $('#error-message-'+id).css('display','none');
                },3000)
            });
    }
    updateCostButton(data, item, onloadFunctionName = '') {

        if (typeof data.update_url == 'undefined') {
            console.log('update_url parameter required ' + this.constructor.name);
            return;
        }
        let url = data.update_url.replace('###', item.product_code)
        url =url.replace('yyy', item.id)

            console.log(url)
        if (onloadFunctionName != '') {
            onloadFunctionName = ' data-onload="' + onloadFunctionName + '" ';
        }

        let dataString = JSON.stringify(data);
        dataString = btoa(dataString);

        return `
            <div class="text-center">
                <span class="btn btn-success btn-circle btn-sm open-modal" data-url="` + url + `" ` + onloadFunctionName + ` data-data="` + dataString + `">
                    <i class="fas fa-pen"></i>
                </span>
            </div>`
    }

    orderViewButton(data, item, onloadFunctionName = '') {

        if (typeof data.update_url == 'undefined') {
            console.log('update_url parameter required ' + this.constructor.name);
            return;
        }
        let url = data.order_url.replace('###', item.order_id)

        console.log(url)
        if (onloadFunctionName != '') {
            onloadFunctionName = ' data-onload="' + onloadFunctionName + '" ';
        }

        let dataString = JSON.stringify(data);
        dataString = btoa(dataString);

        return `<span class="btn btn-primary btn-sm open-modal" data-url="` + url + `"` + onloadFunctionName +` data-data="` + dataString + `" >
                                                           <b>`+item.order_id+`</b>
                                                       </span>`
    }

}
